module.exports = __webpack_public_path__ + "media/images/lamp/logo-a1e99b6ac0e68e9fc43323d205fda7f8.png";